export default function SpinnerSmall({ black }: { black?: boolean }) {
  return (
    <div className="flex justify-center items-center w-full">
      <span
        className="spinnerSmall"
        style={{ borderColor: black ? "#000000" : "#ffffff" }}
      />
    </div>
  );
}
